import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MenuAsideService } from '../../../../../core/_base/layout';
import { AppHotelService } from '../../../../../provider/app-hotel.service';
import { DatasetService } from '../../../../../provider/dataset.service';
import { FollowService } from '../../../../../provider/follow.service';
import { ProfileVisitDetailService } from '../../../../../provider/profile-visit-detail.service';
import { ProfileService } from '../../../../../provider/profile.service';
import { RequestsService } from '../../../../../provider/requests.service';
import { SurveyHeaderService } from '../../../../../provider/survey-header.service';
import { ProfileEditPopup } from '../../../../component/popup/profile-edit/profile-edit.popup';
import { AppHotelModel } from '../../../../models/app-hotel.model';
import { DatasetModel } from '../../../../models/dataset.model';
import { ProfileModel } from '../../../../models/profile.model';
import { RequestHeaderModel } from '../../../../models/request-header.model';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'kt-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  guestVisible: boolean;
  ChatIsVisible = false;
  id: number;
  total = 0;
  popupVisible = false;
  currentRequest: RequestHeaderModel = null;
  currentHotelInfo: AppHotelModel;
  test: any[][] = [[]];
  profile: ProfileModel = new ProfileModel(0, 0, new Date(), new Date(), '', '', '', '', '', '', 0, '' +
    '', new Date(), new Date(), '', '', '', '', '', '', '', '', '',
    '', new Date(), new Date(), '', '', '', '', new Date(), '',
    '', true, true, '', '', new Date(), false, '', '', '', '', true, false, '',
    '', '', '', '', '', '', new Date(), '');
  requests: RequestHeaderModel[] = [];
  rateData: DatasetModel[] = [];
  durationData: DatasetModel[] = [];
  priceData: DatasetModel[] = [];
  requestData: DatasetModel[] = [];
  issueData: DatasetModel[] = [];

  avgSurvey = 0;
  totalRequest = 0;
  totalSpending = 0;
  pendingRequest = 0;
  pendingReservation = 0;

  @Input() ID: number;

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;


  constructor(
    private myService: ProfileService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public surveyService: SurveyHeaderService,
    public reqService: RequestsService,
    private appHotel: AppHotelService,
    public visitDetail: ProfileVisitDetailService,
    private menuAsideService: MenuAsideService,
    private datasetService: DatasetService,
    public followService: FollowService,
    private changeDetect: ChangeDetectorRef
  ) {
    this.reqService.getRequest();
    this.appHotel.getHotelInfo(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(
      (hotelInfo: AppHotelModel) => {
        this.currentHotelInfo = hotelInfo;
      }
    );
  }

  ngOnInit() {
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.guestVisible = JSON.parse(localStorage.getItem('token_form')).guest_visible;

    const ID = this.route.snapshot.params.id;

    if (ID) {
      this.id = +ID;
      this.myService.getProfilebyID(ID).subscribe((resp: ProfileModel) => {
        this.profile = resp;
        if (!this.guestVisible) {
          let first: string = this.profile.first_name.substring(0, 1);
          let last: string = this.profile.last_name.substring(0, 1);
          for (let i = 1; this.profile.first_name.length > i; i++) {
            first += '*';
          }
          for (let i = 1; this.profile.last_name.length > i; i++) {
            last += '*';
          }
          this.profile.first_name = first;
          this.profile.last_name = last;
        }
      });

      this.followService.getFollows(this.id);

      // Survey profile id ile ilgili
      this.surveyService.getSurveyResearchByID(this.id);
      this.surveyService.survey_result_change$.subscribe((datas) => {
        this.avgSurvey = 0;
        if (datas) {
          datas.forEach(x => {
            this.avgSurvey += x.rate;
          });
          if (datas.length != 0) {
            this.avgSurvey = +(this.avgSurvey / (datas.length)).toFixed(2);
          }
        }

      });

      // Request profile id ile ilgili
      this.reqService.getRequestByProfileID(this.id);
      this.reqService.request_profile_change$.subscribe((datas) => {
        this.totalRequest = datas.length;
        this.total = 0;
        datas.forEach(x => this.total += x.point);
        const pending = datas.filter(x => x.managed !== true);
        this.pendingRequest = pending.length;
      });

      this.reqService.getRequestByProfileId(this.id);
      this.reqService.spending_change.subscribe((datas) => {
        let spending = 0;
        datas.forEach(x => {
          spending += x.amount;
        });
        this.totalSpending = spending;
      });

      // Rez request profile id ile ilgili

      this.reqService.getReservationRequestByID(this.id);
      this.reqService.request_reservation_change$.subscribe((datas) => {
        // this.totalRequest += datas.length;
        const pending = datas.filter(x => x.managed !== true);
        this.pendingReservation = pending.length;
      });

      this.visitDetail.getVisitDetailbyID(this.id);
      this.visitDetail.getVisitbyID(this.id);
      this.visitDetail.visitDetail_change$.subscribe((datas) => {
      });

      this.datasetService.getData();

      this.datasetService.record_change$.subscribe(
        (resp: DatasetModel[]) => {
          const filteredData = resp.filter(x => x.profile_id == this.id);
          this.rateData = filteredData.filter(x => x.rating != 0);
          this.durationData = filteredData.filter(x => x.duration >= 0 && x.reason_type == 'request');
          this.requestData = filteredData.filter(x => x.reason_type == 'request');
          this.priceData = filteredData.filter(x => x.price != 0 && x.item != '');
          this.issueData = filteredData.filter(x => x.sub == 'Arıza' && x.item != '');
        }
      );

    }
  }

  generatePdf() {
    const documentDefinition = {
      content: [
        'Talep No / Request No :' + this.currentRequest.id,
        'Talep Tarihi / Request Order Date :' + this.currentRequest.order_date,

        {
          text: this.currentHotelInfo.name,
          style: 'header'
        },
        'Adres / Address :' + this.currentHotelInfo.address,
        'Telefon / Phone :' + this.currentHotelInfo.contact_phone,
        'Email :' + this.currentHotelInfo.contact_email,


        {
          text: 'Sayın / Customer :' + this.currentRequest.profile_name,
          style: 'header'
        },
        'Oda No / Table No :' + this.currentRequest.room_no,
        'Telefon / Phone :' + this.currentRequest.phone_no,
        'Email :' + this.currentRequest.email,
        'Talep Tipi / Request Type :' + this.currentRequest.type,

        {
          style: 'tableExample',
          table: {
            body: [

            ].concat(this.test)
          }
        },

        {
          text: 'Not / Note :' + this.currentRequest.note,
          style: 'subheader'
        },


      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 30, 0, 0],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 0]
        },
        tableExample: {
          margin: [30, 30, 30, 30]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    };
    pdfMake.createPdf(documentDefinition).download();
  }

  Show(data: RequestHeaderModel, type) {
    this.total = 0;
    this.popupVisible = true;
    this.currentRequest = data;

    if (this.currentRequest && this.currentRequest.requestlines) {
      this.currentRequest.requestlines.forEach(x => this.total += x.amount);
    }

    this.test = [[]];

    if (this.currentRequest.requestlines) {
      this.currentRequest.requestlines.forEach((x, i) => {
        let count = 0;
        this.test[i] = [];

        this.test[i][count] = x.menu_item_name;
        if (x.name) {
          count++;
          this.test[i][count] = x.name;
        }

        if (x.request_time) {
          count++;
          this.test[i][count] = x.request_time;
        }
        if (x.quantity != 0) {
          count++;
          this.test[i][count] = x.quantity;
        }
        if (x.unit_of_measure) {
          count++;
          this.test[i][count] = x.unit_of_measure;
        }
        if (x.unit_price != 0) {
          count++;
          this.test[i][count] = x.unit_price;
        }
        if (x.amount != 0) {
          count++;
          this.test[i][count] = x.amount;
        }
      });

    } else {
      return;
    }

  }

  openDialog(id) {
    const dialogRef = this.dialog.open(ProfileEditPopup, { width: '700px', data: { data: this.profile } });
    dialogRef.afterClosed().subscribe((resp) => {
    });
  }

  openChat(data: RequestHeaderModel) {
    this.ChatIsVisible = !this.ChatIsVisible;
    if (this.ChatIsVisible) {
      this.currentRequest = data;
    } else {
      this.currentRequest = new RequestHeaderModel();
    }
  }

  closeChat() {
    this.ChatIsVisible = false;
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.code == 'Escape') {
      this.closeChat();
    }
  }

  customAggregateFunc(aggregationInfo, series) {
    const dataObjects = aggregationInfo.data;
    console.log(dataObjects);
    // ...
    // Aggregate the data objects here
    // ...
    return 5;
  }

  deleteUser(profile: ProfileModel) {
    profile.first_name = '******';
    profile.last_name = '******';
    profile.e_mail = `deleted${new Date().getTime()}@guestny.com`;
    profile.address = '';
    profile.phone_no = '';
    profile.allergy_description = '';

    this.myService.putProfile(profile);
    this.changeDetect.detectChanges();
  }
}
